import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { CookieService } from 'ngx-cookie-service';
import { PagerService } from '../../services/index';
import { Session } from 'protractor';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;
declare var $: any;
@Component({
	selector: 'app-user-survey',
	templateUrl: './user-survey.component.html',
	styleUrls: ['./user-survey.component.css']
})
export class UserSurveyComponent implements OnInit {
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	userName: any;
	email: any;
	phone: any;
	surveyList: any;
	selectedUserId: any;
	profileImage: any;
	prevUrl: any;
	is_from_group = false;
	is_group_survey_report = false;
	id: any;
	deleteSelectedSurveyData: any;
	country: string = "";
	credit: any;


	reviewed_world_survey: number = 0;
	reviewed_country_survey: number = 0;
	reviewed_city_survey: number = 0;
	country_score: number = 0;
	world_score: number = 0;
	city_score: number = 0;
	countryScoreLabel: number = 0;
	cityScoreLabel: number = 0;
	worldScoreLabel: number = 0;
	country_answer: number = 0;
	world_answer: number = 0;
	city_answer: number = 0;
	favcount: number = 0;
	total_like:number = 0;
	like_users_array:any = [];
	like_users_list:any = [];
	showProfileCountArr:any = [];
	
	//getUserList:[];

	isAskSurveyAvailable: boolean = true;
	isSurveyAvailable: boolean = false;
	askWazzersQuestionList: any = [];
	otherQuestionList: any = [];

	constructor(
		private validationService: ValidationService,
		private authService: AuthService,
		private commonService: CommonService,
		private cookieService: CookieService,
		private router: Router,
		private pagerService: PagerService,
		private activatedRoute: ActivatedRoute
	) {
	}

	ngOnInit() {
		this.commonService.process();
		this.activatedRoute.params.subscribe((params: any) => {
			// debugger;;
			if (params.user_id) {

				this.selectedUserId = params.user_id;
				this.prevUrl = params.prev_token;
				this.is_from_group = params.prev_token.indexOf('groupList') > -1 ? true : false;
				this.pager = 1;
				this.limit = 10;

				this.getSelectedUserSurvey(this.pager, this.limit, this.selectedUserId);
				this.getAskWazzersQuestionList(this.selectedUserId);
				this.showProfileCount(this.selectedUserId);
			}
		});


	}

	getGroupMembersList = function (pageNo, limit) {
		this.commonService.process();

		this.authService.getGroupMembersList(pageNo, limit, this.group_id).subscribe(data => {
			if (data.success) {

				var that = this;
				if (pageNo == this.activePageNo)
					setTimeout(function () {
						//jQuery("#search").val(that.searchStr);
						jQuery('#page_' + that.activePageNo).addClass('active');
						if (that.activePageNo == 1)
							jQuery('#first, #prev').addClass('disabled');
						else if (that.activePageNo == that.pager.totalPages)
							jQuery('#next, #last').addClass('disabled');
					}, 300);
				this.groupMemberList = data.members;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = 'pageNo=1&groupList=1';
			}
			else {
				this.isUserAvailable = false;
				this.userList = [];
			}
			this.commonService.hideProcess();
		});
	}

	// Get selected user survey
	getSelectedUserSurvey = function (pageNo, limit, userId) {

		this.commonService.process();
		this.authService.getSelectedUserSurvey(pageNo, limit, userId).subscribe(data => {
		//	console.log(data);
			if (data.success) {

				this.surveyList = data.survey;
				this.total = data.total;
				this.profileImage = this.commonService.imageUrl + this.surveyList[0].user_id.profile_pic;
				this.userName = this.surveyList[0].user_id.name;
				$(".navbar-brand").html(this.userName + '\'s Profile');
				this.email = this.surveyList[0].user_id.email;
				this.phone = this.surveyList[0].user_id.phone;
				
				this.id = userId;


				if (this.surveyList[0].user_id.country_id) {
					this.country = this.surveyList[0].user_id.country_id.country;
				}

				this.total_like = this.surveyList[0].like.length;

				this.surveyList[0].like.forEach(element => {
					this.like_users_array.push(element.userid);
				});

				if(this.total_like > 0){
					this.getLikeUsers(this.like_users_array);
				}
				
				
				this.credit = this.surveyList[0].user_id.credit;

				this.reviewed_world_survey = (this.surveyList[0].user_id.survey_id[0] ? this.surveyList[0].user_id.survey_id[0].world_survey : 0);
				this.reviewed_country_survey = (this.surveyList[0].user_id.survey_id[1] ? this.surveyList[0].user_id.survey_id[1].country_survey : 0);
				this.reviewed_city_survey = (this.surveyList[0].user_id.survey_id[2] ? this.surveyList[0].user_id.survey_id[2].city_survey : 0);


				// this.world_answer = this.surveyList[0].user_id.world_answer;
				// this.world_score = this.surveyList[0].user_id.world_score;
				// this.country_score = this.surveyList[0].user_id.country_score;
				// this.city_score = this.surveyList[0].user_id.city_score;
				 this.favcount = this.surveyList[0].user_id.favcount;

				// if (this.world_answer === -1) {
				// 	this.world_answer = 0;
				// }

				// this.worldScoreLabel = (data.setting ? data.setting.world_score : 0);
				// this.countryScoreLabel = (data.setting ? data.setting.country_score : 0);
				// this.cityScoreLabel = (data.setting ? data.setting.city_score : 0);
				// this.country_answer = (data.setting ? this.surveyList[0].user_id.country_answer : 0);

				// if (this.country_answer === -1) {
				// 	this.country_answer = 0;
				// }

				// this.city_answer = this.surveyList[0].user_id.city_answer;

				// if (this.city_answer === -1) {
				// 	this.city_answer = 0;
				// }


				this.setPage(pageNo, true);

			} else {

				this.authService.getUserProfile(userId).subscribe(data => {

					if (data.success) {
						this.profileImage = this.commonService.imageUrl + data.user.profile_pic;
						this.userName = data.user.name;
						$(".navbar-brand").html(this.userName + '\'s Profile');
						this.email = data.user.email;
						this.phone = data.user.phone;

						if (data.user.country_id) {
							this.country = data.user.country_id.country;
						}

						this.credit = data.user.credit;

						this.reviewed_world_survey = (data.user.survey_id[0] ? data.user.survey_id[0].world_survey : 0);
						this.reviewed_country_survey = (data.user.survey_id[1] ? data.user.survey_id[1].country_survey : 0);
						this.reviewed_city_survey = (data.user.survey_id[2] ? data.user.survey_id[2].city_survey : 0);

						this.world_answer = data.user.world_answer;
						this.world_score = data.user.world_score;
						this.country_score = data.user.country_score;
						this.city_score = data.user.city_score;
						this.favcount = data.user.favcount;

						if (this.world_answer === -1) {
							this.world_answer = 0;
						}

						this.worldScoreLabel = (data.setting ? data.setting.world_score : 0);
						this.countryScoreLabel = (data.setting ? data.setting.country_score : 0);
						this.cityScoreLabel = (data.setting ? data.setting.city_score : 0);
						this.country_answer = (data.setting ? data.user.country_answer : 0);

						if (this.country_answer === -1) {
							this.country_answer = 0;
						}

						this.city_answer = data.user.city_answer;

						if (this.city_answer === -1) {
							this.city_answer = 0;
						}

					}
				});
			}
			this.commonService.hideProcess();
		});
	}

	getAskWazzersQuestionList = function (user_id) {

		this.authService.askWazzers(user_id).subscribe(data => {

			if (data.success) {
				this.askWazzersQuestionList = data.result;
				this.otherQuestionList = data.otherquestion;
				if (this.otherQuestionList.length === 0) {
					this.isSurveyAvailable = false;
				}

				if (this.askWazzersQuestionList.length === 0) {
					this.isAskSurveyAvailable = false;
				}

				this.commonService.hideProcess();
			} else {

				this.askWazzersQuestionList = [];
				this.otherQuestionList = [];

			}
		});

	}

	getLikeUsers = function(usersArr){
		this.like_users_list = [];

		this.authService.getLikeUsers(usersArr).subscribe(data => {
			if (data.success) {
				this.like_users_list = data.result;
				console.log(this.like_users_list);
			} 
		});

	}

	
	showProfileCount = function(user_id){
		this.showProfileCountArr = [];
		this.authService.showProfileCount(user_id).subscribe(data => {
			if (data.success) {
				this.showProfileCountArr = data;
				console.log(this.showProfileCountArr);
			} 
		});
	}


	
	// // Delete selected Survey Details
	// deleteSelectedSurvey = function (survey) {

	// 	this.isDeleteSurvey = true;
	// 	this.deleteSelectedSurveyData = survey
	// }
	// // Delete Survey
	// deleteSurvey = function (id) {
	// 	this.authService.deleteSurveyComment(id).subscribe(data => {
	// 		if (data.success) {
	// 			this.authService.cancelProcess();
	// 			this.getSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
	// 			jQuery.growl.notice({ title: 'Success', message: data.message });
	// 		}
	// 		else {
	// 			jQuery.growl.error({ title: 'Error', message: data.error });
	// 		}
	// 	});
	// }
	// // show button
	// showDeleteButton = function () {        // debugger;;
	// 	$("#butDelete").show;
	// }
	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getSelectedUserSurvey(page, this.limit, this.selectedUserId);
		}
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/user-survey/user-survey.component.ts